import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const SelectModal = ({
  show,
  onHide,
  title,
  loading = false,
  options = [],
  value = "",
  onChange,
  onSelect,
  optionLabel = (opt) => opt.name,
  optionValue = (opt) => opt.id,
  confirmButtonText,
  cancelButtonText,
  emptyMessage,
  loadingMessage,
  topContent = null,
}) => {
  const { t } = useTranslation("layout");
  const resolvedTitle = title ?? t("selectModal.title");
  const resolvedConfirm = confirmButtonText ?? t("selectModal.confirm");
  const resolvedCancel = cancelButtonText ?? t("selectModal.cancel");
  const resolvedEmpty = emptyMessage ?? t("selectModal.empty");
  const resolvedLoading = loadingMessage ?? t("selectModal.loading");

  const handleConfirm = () => {
    if (value) {
      const selectedOption = options.find((opt) => optionValue(opt) === value);
      onSelect(selectedOption);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{resolvedTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {topContent}
        {loading ? (
          <div>{resolvedLoading}</div>
        ) : options.length > 0 ? (
          <>
            <select
              className="form-control"
              value={value}
              onChange={(e) => onChange(e.target.value)}>
              <option value="">{resolvedTitle}</option>
              {options.map((option) => (
                <option key={optionValue(option)} value={optionValue(option)}>
                  {optionLabel(option)}
                </option>
              ))}
            </select>
          </>
        ) : (
          <div>{resolvedEmpty}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {resolvedCancel}
        </Button>
        <Button
          variant="primary"
          disabled={!value || loading}
          onClick={handleConfirm}>
          {resolvedConfirm}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectModal;
